export const Routes = {
  home: '/',
  recoverPassword: '/recover-password',
};
